const metadata = {
  id: 5,
  name: `How to Use Case Studies for Learning`,
  metadata: {
    description: [],
    objectives: [],
    themes: [],

  },
  image:
    "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/pexels-kampus-6248968.jpg",
  slug: "how-to-use-case-studies-for-learning",
  title: `How to Use Case Studies for Learning`,
}

export default metadata;